import React from "react";
import BreadcrumbItem from "../component/BreadcrumbItem/BreadcrumbItem";
import Page from "../component/Page/Page";
import ReadpointForm from "./component/ReadpointForm";

class ReadpointFormPage extends React.Component {
  render() {
    const {match, history} = this.props;
    const breadcrumbs = [
      <BreadcrumbItem key={1} title="Configurações"/>,
      <BreadcrumbItem key={2} title="Lista de Ponto de Leitura"
                      to="/list/readpoints"/>,
      <BreadcrumbItem key={3} title="Dados do Ponto de Leitura"
                      active={true}/>];
    return (
        <Page title="Dados do Ponto de Leitura" breadcrumbs={breadcrumbs}>
          <ReadpointForm match={match} history={history}/>
        </Page>
    );
  }
}

export default ReadpointFormPage;



// WEBPACK FOOTER //
// ./src/readpoint/ReadpointFormPage.js